<template>
    <relatorio-page :titulo=" 'Relatório do Balancete Financeiro' " :cabecalhoCompleto="true" :exportarExcel="true" :paisagem="filter.lista ? true : false">
        
        <div class="my-1">
            <span class="mr-2 font-weight-bold">Período do Balancete:</span>
            <span class="mr-2 font-weight-bold">{{new Date(filter.dataInicio).ddmmyyyy()}}</span>
            <span class="mr-2 font-weight-bold">até</span>
            <span class="mr-2 font-weight-bold">{{new Date(filter.dataFim).ddmmyyyy()}}</span>
            <v-divider/>
        </div>

        <div v-if="item != null">
            
            <v-simple-table id="tabela" v-if="filter.lista" dense class="py-2 text-caption">
                <template v-slot: default>
                    <thead class="fonte" style="background-color: #4A70A8">
                        <tr>
                            <th style="font-size: 75% ; color: white" class="text-left fonte">Plano Conta</th>
                            <th style="font-size: 75% ; color: white" class="text-left fonte">Plano Conta (Item)</th>
                            <th style="font-size: 75% ; color: white" class="text-left fonte">Data</th>
                            <th style="font-size: 75% ; color: white" class="text-left fonte">Descrição</th>
                            <th style="font-size: 75% ; color: white" class="text-left fonte">Fornecedor / Doador</th>
                            <th style="font-size: 75% ; color: white" class="text-left fonte">Banco</th>
                            <th style="font-size: 75% ; color: white" class="text-left fonte">Doc.</th>
                            <th style="font-size: 75% ; color: white" class="text-left fonte">Valor</th>
                        </tr>
                    </thead>
                    <tbody class="fonte" v-for="(item, index) in item" :key="index" :style=" index % 2 === 0 ? 'background-color: gainsboro' : 'background-color: White'">
                        <tr>
                            <td class="text-left" style="font-size: 75%">{{item.planoConta}}</td>
                            <td class="text-left" style="font-size: 75%">{{item.planoContaItem}}</td>
                            <td class="text-left" style="font-size: 75%">{{new Date(item.data).ddmmyyyy()}}</td>
                            <td class="text-left" style="font-size: 75%">{{item.descricao}}</td>
                            <td class="text-left" style="font-size: 75%">{{item.nome}}</td>
                            <td class="text-left" style="font-size: 75%">{{item.banco}}</td>
                            <td class="text-left" style="font-size: 75%">{{item.documento}}</td>
                            <td class="text-left" style="font-size: 75%">{{item.valor.toMoeda(true)}}</td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>

            <v-simple-table id="tabela" v-else dense class="py-2 text-caption">
                <template v-slot:default>
                    <tr>
                        <td colspan="3">
                            <v-simple-table dense>
                                <template v-slot:default>
                                    <thead class="fonte" style="background-color: #4A70A8">
                                        <tr>
                                            <th style="font-size: 100% ; color: white ; width: 650px" class="text-left fonte">Contas Financeiras</th>
                                            <th></th>
                                            <th style="font-size: 100% ; color: white ; width: 150px" class="text-right fonte">Valores</th>
                                            <th style="font-size: 100% ; color: white ; width: 150px" class="text-right fonte">% do Total</th>
                                        </tr>
                                    </thead>
                                    <tbody class="fonte" v-for="(receita, index) in item.receitas" :key="index">
                                        <tr>
                                            <td class="text-left font-weight-bold" style="font-size: 100% ; width: 650px">{{receita.grupo}}</td>
                                            <td></td>
                                            <td class="text-right font-weight-bold" style="font-size: 100% ; width: 150px">{{receita.valorTotal? receita.valorTotal.toMoeda(true) : Number(0).toMoeda()}}</td>
                                            <td class="text-right font-weight-bold" style="font-size: 100% ; width: 150px">{{receita.porcentagem? receita.porcentagem.toPercentual() : Number(0).toPercentual()}}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="4" class="pa-0">
                                                <v-simple-table dense>
                                                    <template v-slot:default>
                                                        <tbody class="fonte" v-for="(item, index) in receita.itens" :key="index" :style=" index % 2 === 0 ? 'background-color: gainsboro' : 'background-color: White'">
                                                            <tr>
                                                                <td></td>
                                                                <td class="text-left" style="font-size: 100% ; width: 650px"><span></span><a @click="AbrirDetalhes(item)">{{item.planoContasItem}}</a></td>
                                                                <td class="text-right" style="font-size: 100% ; width: 150px">{{item.valor? item.valor.toMoeda(true) : Number(0).toMoeda()}}</td>
                                                                <td class="text-right" style="font-size: 100% ; width: 150px">{{item.porcentagem? item.porcentagem.toPercentual() : Number(0).toPercentual()}}</td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot style="background-color: #4A70A8">
                                        <tr>
                                            <th colspan="2" style="font-size: 100% ; color: white" class="text-right fonte">Total Receitas:</th>
                                            <th style="font-size: 100% ; color: white" class="text-right fonte">{{item.totalReceitas? item.totalReceitas.toMoeda(true) : Number(0).toMoeda()}}</th>
                                            <th style="font-size: 100% ; color: white" class="text-right fonte">{{item.totalPorcentagemReceitas? item.totalPorcentagemReceitas.toPercentual() : Number(0).toPercentual()}}</th>
                                        </tr>
                                    </tfoot>
                                </template>
                            </v-simple-table>
                            <v-simple-table dense>
                                <template v-slot: default>
                                    <tbody class="fonte" v-for="(despesa, index) in item.despesas" :key="index">
                                        <tr>
                                            <td class="text-left font-weight-bold" style="font-size: 100% ; width: 650px">{{despesa.grupo}}</td>
                                            <td></td>
                                            <td class="text-right font-weight-bold" style="font-size: 100% ; width: 150px">{{despesa.valorTotal? despesa.valorTotal.toMoeda(true) : Number(0).toMoeda()}}</td>
                                            <td class="text-right font-weight-bold" style="font-size: 100% ; width: 150px">{{despesa.porcentagem? despesa.porcentagem.toPercentual() : Number(0).toPercentual()}}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="4" class="pa-0">
                                                <v-simple-table dense>
                                                    <template v-slot:default>
                                                        <tbody class="fonte" v-for="(item, index) in despesa.itens" :key="index" :style=" index % 2 === 0 ? 'background-color: gainsboro' : 'background-color: White'">
                                                            <tr>
                                                                <td></td>
                                                                <td class="text-left" style="font-size: 100% ; width: 650px"><span></span><a @click="AbrirDetalhes(item)">{{item.planoContasItem}}</a></td>
                                                                <td class="text-right" style="font-size: 100% ; width: 150px">{{item.valor? item.valor.toMoeda(true) : Number(0).toMoeda()}}</td>
                                                                <td class="text-right" style="font-size: 100% ; width: 150px">{{item.porcentagem? item.porcentagem.toPercentual() : Number(0).toPercentual()}}</td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot style="background-color: #4A70A8">
                                        <tr>
                                            <th colspan="2" style="font-size: 100% ; color: white" class="text-right fonte">Total Despesas:</th>
                                            <th style="font-size: 100% ; color: white" class="text-right fonte">{{item.totalDespesas? item.totalDespesas.toMoeda(true) : Number(0).toMoeda()}}</th>
                                            <th style="font-size: 100% ; color: white" class="text-right fonte">{{item.totalPorcentagemDespesas? item.totalPorcentagemDespesas.toPercentual() : Number(0).toPercentual()}}</th>
                                        </tr>
                                    </tfoot>
                                </template>
                            </v-simple-table>
                        </td>
                    </tr>
                    <tr>                        
                        <td style="font-size: 100%" class="text-right fonte font-weight-bold">
                            <span>Resultado: </span>
                        </td>
                        <td style="font-size: 100%" class="text-right fonte font-weight-bold">
                            <span>{{item.resultado? item.resultado.toMoeda(true) : Number(0).toMoeda()}}</span>
                        </td>
                        <td style="font-size: 100%" class="text-right fonte font-weight-bold">
                            <span>{{item.resultadoPorcentagem? item.resultadoPorcentagem.toPercentual() : Number(0).toPercentual()}}</span>
                        </td>
                    </tr>
                </template>                
            </v-simple-table>
        </div>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-dialog v-model="dialog" width="80vw">
            <v-card>
                <v-card-title class="pa-0">
                    <v-toolbar dark color="primary">
                        <span>Detalhamento do Balancete Financeiro</span>
                        <v-spacer/>
                        <v-toolbar-items>
                            <v-btn icon dark @click="FecharDetalhes()"><v-icon>mdi-close</v-icon></v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                </v-card-title>
                <v-card-text class="mt-3">
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <v-simple-table dense class="py-2 text-caption">
                                <template v-slot: default>
                                    <thead class="fonte" style="background-color: #4A70A8">
                                        <tr>
                                            <th style="font-size: 100% ; color: white" class="text-left fonte">Data</th>
                                            <th style="font-size: 100% ; color: white" class="text-left fonte">Descrição</th>
                                            <th style="font-size: 100% ; color: white" class="text-left fonte">Fornecedor / Doador</th>
                                            <th style="font-size: 100% ; color: white" class="text-left fonte">Banco</th>
                                            <th style="font-size: 100% ; color: white" class="text-left fonte">Doc.</th>
                                            <th style="font-size: 100% ; color: white" class="text-left fonte">Valor</th>
                                        </tr>
                                    </thead>
                                    <tbody class="fonte" v-for="(detalhe, index) in detalhes" :key="index" :style=" index % 2 === 0 ? 'background-color: gainsboro' : 'background-color: White'">
                                        <tr>
                                            <td class="text-left" style="font-size: 100%">{{new Date(detalhe.data).ddmmyyyy()}}</td>
                                            <td class="text-left" style="font-size: 100%">{{detalhe.descricao}}</td>
                                            <td class="text-left" style="font-size: 100%">{{detalhe.nome}}</td>
                                            <td class="text-left" style="font-size: 100%">{{detalhe.banco}}</td>
                                            <td class="text-left" style="font-size: 100%">{{detalhe.documento}}</td>
                                            <td class="text-left" style="font-size: 100%">{{detalhe.valor.toMoeda(true)}}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

    </relatorio-page>
</template>

<script>
import FluxoBancarioService from '../../../core/services//financeiro/FluxoBancarioService';

export default {
    
    data: () => ({
        item:{
            required: true
        },
        filter:{
            dataInicio: '',
            dataFim: '',
            projetoId: null,
            lista: false
        },
        service: new FluxoBancarioService(),
        overlay: false,
        dialog: false,
        detalhes: null
    }),
    props:{
        
    },
    created(){
        this.filter.dataInicio = this.$route.query.dataInicio;
        this.filter.dataFim = this.$route.query.dataFim;
        this.filter.projetoId = this.$route.query.projetoId;
        this.filter.lista = this.$route.query.lista == "true" ? true : false;
    },
    mounted(){        
        this.overlay = true;
        this.Carregar();
    },
    methods:{
        Carregar(){
            if(this.filter.lista){
                this.RelatorioBalanceteListagem();
            }
            else{
                this.ObterBalacete();
            }
        },
        ObterBalacete(){
            this.service.ObterBalancete(this.filter.dataInicio, this.filter.dataFim, this.filter.projetoId).then(
                res =>{
                    let resultado = res.data;
                    resultado.receitas = resultado.receitas.sort(function(a, b){
                        if(a.grupo > b.grupo)
                            return 1;
                        if(a.grupo < b.grupo)
                            return -1;
                        return 0;
                    });
                    resultado.receitas.forEach(receita => {
                        receita.itens = receita.itens.sort(function(a, b){
                            if(a.planoContasItem > b.planoContasItem)
                                return 1;
                            if(a.planoContasItem < b.planoContasItem)
                                return -1;
                            return 0;
                        });
                    });
                    resultado.despesas = resultado.despesas.sort(function(a, b){
                        if(a.grupo > b.grupo)
                            return 1;
                        if(a.grupo < b.grupo)
                            return -1;
                        return 0;
                    });
                    resultado.despesas.forEach(despesa => {
                        despesa.itens = despesa.itens.sort(function(a, b){
                            if(a.planoContasItem > b.planoContasItem)
                                return 1;
                            if(a.planoContasItem < b.planoContasItem)
                                return -1;
                            return 0;
                        });
                    });
                    this.item = resultado;
                },
                err => this.$swal('Aviso', err.message, 'error')
            ).finally(() =>{
                this.overlay = false;
            })
        },
        AbrirDetalhes(val){
            this.dialog = true;
            this.service.DetalharBalancete(val.planoContasId, val.planoContasItemId, this.filter.dataInicio, this.filter.dataFim, this.filter.projetoId).then(
                res =>{
                    this.detalhes = res.data
                },
                err => this.$swal('Aviso', err.message, 'error')
            )
        },
        RelatorioBalanceteListagem(){
            this.service.RelatorioBalanceteListagem(this.filter.dataInicio, this.filter.dataFim).then(
                res => {
                    this.item = res.data                    
                },
                err => this.$swal('Aviso', err.message, 'error')
            ).finally(() =>{
                this.overlay = false;
            })
        },
        FecharDetalhes(){
            this.dialog = false;
            this.detalhes = null;
        }
    }   

}
</script>
